import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { company, domains, services, zones } from '../data/site';
export function Footer() {
  return <footer className="bg-navy-800 text-navy-100" data-id="element-54" data-mp="32onkf2vm5o8y">
      <div className="mx-auto max-w-content px-5 pb-28 pt-14 lg:px-8 lg:py-16" data-id="element-55" data-mp="32m1bozwzl2p5">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-8" data-id="element-56" data-mp="36ppktn19o6ci">
          <div className="lg:col-span-5" data-id="element-57" data-mp="3uesbtlhsjbjo">
            <p className="font-display text-xl font-extrabold text-white" data-id="element-58" data-mp="3ucxpc2qvfbdh">
              {company.name}
            </p>
            <p className="mt-2 text-sm text-navy-200" data-id="element-59" data-mp="3lecb2jsfmiii">{company.tagline}</p>
            <address className="mt-6 space-y-3 text-sm not-italic" data-id="element-60" data-mp="3le2fmgombj5f">
              <a href={company.phoneHref} className="flex items-center gap-3 whitespace-nowrap font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:text-ember-300" data-id="element-61" data-mp="3qcdpgrewxtnn">
                <PhoneIcon className="h-4 w-4 shrink-0 text-ember-300" aria-hidden="true" data-id="element-62" data-mp="2evxb71f3hj2d" />
                {company.phone}
              </a>
              <a href={company.emailHref} className="flex items-center gap-3 text-navy-100 transition-colors duration-150 ease-out hover:text-white" data-id="element-63" data-mp="3gctq2qlywtse">
                <MailIcon className="h-4 w-4 text-ember-300" aria-hidden="true" data-id="element-64" data-mp="3qazr75zy9vw7" />
                {company.email}
              </a>
              <p className="flex gap-3 text-navy-200" data-id="element-65" data-mp="34gvldp1el60">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember-300" aria-hidden="true" data-id="element-66" data-mp="33nogbm61tnc" />
                <span data-id="element-67" data-mp="ctgw51j6tomb">
                  {company.owner}
                  <br data-id="element-68" data-mp="cw33b0262240" />
                  {company.addressLines.join(' · ')}
                </span>
              </p>
            </address>
          </div>

          <div className="lg:col-span-3" data-id="element-69" data-mp="msxzvdevpsfn">
            <h2 className="font-display text-xs font-bold uppercase tracking-[0.16em] text-ember-300" data-id="element-70" data-mp="mptsk764agkr">
              Nos prestations
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-71" data-mp="yv94bte2a0vr">
              {services.map(s => <li key={s.key} data-id="element-72" data-mp="13t0t4ejet6vq">
                  <Link to={s.path} className="text-navy-100 transition-colors duration-150 ease-out hover:text-white" data-id="element-73" data-mp="13rzj8de4qqfl">
                    {s.label}
                  </Link>
                </li>)}
              <li data-id="element-74" data-mp="1hjntsc8qd6ug">
                <Link to="/contact" className="text-navy-100 transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="1hj4aar3fmaeb">
                  Demander un devis
                </Link>
              </li>
            </ul>
            <p className="mt-5 text-xs text-navy-300" data-id="element-76" data-mp="3oboq3o2u9xl9">
              Domaines : {domains.join(', ')}.
            </p>
          </div>

          <div className="lg:col-span-4" data-id="element-77" data-mp="3tarrmyjm1loh">
            <h2 className="font-display text-xs font-bold uppercase tracking-[0.16em] text-ember-300" data-id="element-78" data-mp="2af3upvql3dm9">
              Zone d'intervention
            </h2>
            <p className="mt-4 text-sm text-navy-200" data-id="element-79" data-mp="25mu74mcxypn5">
              Toute la Corrèze, notamment :
            </p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-80" data-mp="21n1xe6btadg7">
              {zones.map(z => <li key={z} className="rounded-lg bg-navy-700 px-2.5 py-1.5 text-xs font-medium text-navy-100" data-id="element-81" data-mp="1wpjvgzw7oyhp">
                  {z}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-navy-700 pt-6 text-xs text-navy-300 sm:flex-row sm:items-center sm:justify-between" data-id="element-82" data-mp="2kc8h9wocdb3l">
          <p data-id="element-83" data-mp="2fgkpd9ih63ue">
            © {new Date().getFullYear()} {company.name} — {company.owner}. Tous
            droits réservés.
          </p>
          <p data-id="element-84" data-mp="13ys187ypijx0">{company.devisNote}</p>
        </div>
      </div>
    </footer>;
}